module.exports = __webpack_public_path__ + "media/13-3.d87f6f5a.mp3";